import React, { Component } from "react";
import { ApGetProfile_Url } from "../../../provider/ServiceUrl";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";

class AdminProfile extends Component {
  header = store.getState().adminHeader.adminHeader;
  breadCrumb = [{ pageid: "", uiname: "User profile" }];
  title = "User profile";
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    };
    this.getProfileDetails();
  }

  getProfileDetails() {
    const postObject = {
      header: this.header,
    };

    AdminFetchServerData.callPostService(ApGetProfile_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let profileDetails = output.data.appuser;
          this.setState({
            render: true,
            id: profileDetails.id,
            firstName: profileDetails.firstName,
            lastName: profileDetails.lastName,
            email: profileDetails.email,
            phone: profileDetails.phone,
            userStatus: profileDetails.userStatus,
            profile: profileDetails.profile,
          });
        }
      }
    );
  }

  render() {
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
        />
        <div className="row" style={{ padding: "1em", marginTop: "-12px" }}>
          <div className="card" id="organizationFormCard">
            <div className="row">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="row pt-1">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Name
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        <span>
                          {this.state.firstName + " " + this.state.lastName}
                        </span>
                      </div>
                    </div>
                    <div className="row pt-1">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Phone
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        <span>{this.state.phone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="row pt-1">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Email
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        <span>{this.state.email}</span>
                      </div>
                    </div>
                    <div className="row pt-1">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Status
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        <span>{this.state.userStatus?.status}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="row pt-1">
                      <label
                        className="col-sm-3 col-form-label fw-bold"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Profile
                      </label>
                      <div className="col-sm-9" id="OrganizationCol">
                        <span>{this.state.profile?.name}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="mt-4 text-center"> */}
          {/* <Button
          type="submit"
          variant="contained"
          size="small"
          style={{
            background: "#717373",
            color: "#fff",
            marginRight: "1rem",
          }}
          startIcon={<ArrowBackIcon />}
          onClick={(e) => this.viewCancel()}
        >
          Back
        </Button> */}
          {/* </div> */}
        </div>
      </>
    );
  }
}
export default AdminProfile;
